export default __webpack_public_path__ + "static/media/sun_capital_facility.c91a6e4c.png";